/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The loading component for Chart Dynamic
 *
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.1.0
 */

import {
    EChartDataKeyEnum,
    IChartDataInput,
    IChartDataOutput,
    IChartLoadingConfiguration,
    IChartScaleConfiguration,
} from '../../chartTypes';

/*
* -------------------------------------------
*           CHART DATA
* -------------------------------------------
*/

const ChartDynamicDataOutputLoading: IChartDataOutput[] = [
    {
        [EChartDataKeyEnum.name]: 'name1',
        [EChartDataKeyEnum.x]: 'x1',
        [EChartDataKeyEnum.y]: 0,
    },
    {
        [EChartDataKeyEnum.name]: 'name1',
        [EChartDataKeyEnum.x]: 'x2',
        [EChartDataKeyEnum.y]: 0,
    },
    {
        [EChartDataKeyEnum.name]: 'name1',
        [EChartDataKeyEnum.x]: 'x3',
        [EChartDataKeyEnum.y]: 0,
    },
];

/*
* -------------------------------------------
*           CHART LEGEND
* -------------------------------------------
*/

const ChartDynamicLoadingLegendItems: IChartDataInput[] = [
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 6,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: '',
        [EChartDataKeyEnum.y]: {},
    },
];

/*
* -------------------------------------------
*           CHART CONFIGURATION
* -------------------------------------------
*/

const ChartDynamicScaleLoading: IChartScaleConfiguration = {
    [EChartDataKeyEnum.x]: {
        range: [0, 1],
    },
    [EChartDataKeyEnum.y]: {
        max: 1000,
        min: 0,
        tickInterval: 100,
    },
};

export const ChartDynamicLoadingConfiguration: IChartLoadingConfiguration = {
    chartData: ChartDynamicDataOutputLoading,
    height: 476,
    legendItems: ChartDynamicLoadingLegendItems,
    scale: ChartDynamicScaleLoading,
};
